import { ActivitySpinnerSize, ActivitySpinnerWidget } from '@tableau/widgets';
import * as React from 'react';

export function LoadingPoolsSpinner() {
  return (
    <tbody>
      <tr>
        <td colSpan={9}>
          <div className={'tb-data-grid-cell-text tb-data-grid-bridge-center'}>
            <ActivitySpinnerWidget
              spinnerSize={ActivitySpinnerSize.Small}
              testId={'bridge-pools-loading-spinner'}
            />
          </div>
        </td>
      </tr>
    </tbody>);
}
